export default {
  title: 'Download {{app}} App',
  qr_code_desc: 'Scan this QR code with your phone to download the app',
  cta: 'Download the app and sign in to get {{amount}} cashback!',
  download_from: 'Or download from:',
  direct_link: 'Direct link:',
};
